import { createFeature, createReducer, on } from '@ngrx/store';
import * as actions from './rfr-mon-stack.actions';
import * as luxon from 'luxon';
import { RfrMonStackResponseI } from 'src/app/api/rfr-mon-stack/rfr-mon-stack.result.int';

  export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: RfrMonStackResponseI;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
};

export default createFeature({
  name: 'rfrMonStack',
  reducer: createReducer(
  initialState,
  on(actions.load, (state: State): State => ({
    ...state,
    loaded: false,
    loading: true
  })),
  on(actions.received, (state: State, { data }): State => ({
    ...state,
    data,
    error: null,
    loaded: true,
    loading: false,
    receivedTime: luxon.DateTime.now().toISO()
  })),
  on(actions.reset, (state: State): State => ({
    ...state,
    data: null,
    error: null,
    loaded: false,
    loading: false
  })),
  on(actions.error, (state: State, { messageText }): State => ({
    ...state,
    error: messageText,
    loaded: false,
    loading: false
  })),
)}
);
